/* unplugin-vue-components disabled */import { render } from "./BountyList.vue?vue&type=template&id=4a00a2e8&scoped=true"
import script from "./BountyList.vue?vue&type=script&lang=js"
export * from "./BountyList.vue?vue&type=script&lang=js"

import "./BountyList.vue?vue&type=style&index=0&id=4a00a2e8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a00a2e8"]])

export default __exports__